import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { RptAgendaCommercialeDto } from '@api/client';
import { format } from 'date-fns';

const fmtDate = (d?: Date | string | null) => (d ? format(new Date(d as any), 'dd/MM/yyyy') : '');
const fmtDateTime = (d?: Date | string | null) => (d ? format(new Date(d as any), 'dd/MM/yyyy HH:mm') : '');

export const exportAgendaActionsToExcel = (
  actions: RptAgendaCommercialeDto[] | undefined,
  fileName = 'agenda-attivita',
) => {
  const rows = (actions || []).map((a) => ({
    ID: a.id ?? '',
    'Data azione': fmtDate(a.actionDate),
    Cliente: a.nomeAccount ?? a.clienteId ?? '',
    'Referente cliente': a.nominativoCliente ?? '',
    'Modalità contatto': a.modalitaContatto ?? '',
    'Stato attività': a.statoAttivita ?? '',
    Esito: a.esito ?? '',
    'Nota esito': a.notaEsito ?? '',
    Nota: a.nota ?? '',
    'Struttura di business': a.denominazioneStrutturaBusiness ?? a.strutturaBusinessId ?? '',
    Opportunity: a.denominazioneOpportunity ?? a.opportunityId ?? '',
    Progetto: a.projectName ?? a.projectId ?? '',
    'Importo (€)': a.amount ?? '',
    'Margine (€)': a.margin ?? '',
    'Data creazione': fmtDateTime(a.creationDate),
    'Ultima modifica': fmtDateTime(a.lastmodifiedDate),
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Attività');
  const buf = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
};
